import { colorsV2 } from '../../../../colors-v2';

interface LinkItem {
  id: string;
  text?: string;
  url?: string;
  icon?: string;
  iconColor?: keyof typeof colorsV2;
}

export const exploreMoreLinks: LinkItem[] = [
  {
    id: 'gioi_thieu',
    text: 'Giới thiệu',
    url: '/gioi-thieu',
  },
  {
    id: 'chinh_sach_bao_mat',
    text: 'Chính sách bảo mật',
    url: '/chinh-sach-bao-mat',
  },
  {
    id: 'dieu_khoan_su_dung',
    text: 'Điều khoản Sử dụng',
    url: '/dieu-khoan-su-dung',
  },
  {
    id: 'lien_he',
    text: 'Liên hệ',
    url: '/lien-he',
  },
];

export const contactLinks: LinkItem[] = [
  {
    id: 'address',
    text: 'Hẻm 458/14,  3/2, P12, Q10, TP.HCM',
    url: 'https://g.page/dolenglish?share',
    icon: 'pin',
    iconColor: 'primary100',
  },
  {
    id: 'messenger',
    text: 'm.me/dolieltslinear',
    url: 'https://m.me/dolenglish.ieltsdinhluc',
    icon: 'messenger',
    iconColor: 'blue80',
  },
  {
    id: 'phone',
    text: '(+84) 356 307 668',
    url: 'tel:+84356307668',
    icon: 'phone',
    iconColor: 'green80',
  },
];

export const socialButtons: LinkItem[] = [
  {
    id: 'facebook',
    url: 'https://www.facebook.com/dolacademy.vn',
    icon: 'facebook',
    iconColor: 'blue100',
  },
  {
    id: 'youtube',
    url: 'https://www.youtube.com/channel/UCEhPLLt928jxgOGDtyzgV9g',
    icon: 'youtube',
    iconColor: 'red100',
  },
  {
    id: 'tiktok',
    url: 'https://www.tiktok.com/@dolenglish',
    icon: 'tiktok',
    iconColor: 'black100',
  },
];
